var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglassCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    fill: "#EFEFEF",
    stroke: "#ACADAE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5L12.675 13.65C12.621 13.6031 12.5771 13.5426 12.5468 13.4733C12.5164 13.4039 12.5004 13.3275 12.5 13.25V11C12.5 10.8674 12.5461 10.7402 12.6281 10.6464C12.7102 10.5527 12.8215 10.5 12.9375 10.5H19.0625C19.1785 10.5 19.2898 10.5527 19.3719 10.6464C19.4539 10.7402 19.5 10.8674 19.5 11V13.225C19.4996 13.3025 19.4836 13.3789 19.4532 13.4483C19.4229 13.5176 19.379 13.5781 19.325 13.625L16 16.5Z",
    stroke: "#ACADAE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5L12.675 18.875C12.621 18.9141 12.5771 18.9645 12.5468 19.0223C12.5164 19.0801 12.5004 19.1437 12.5 19.2083V21.0833C12.5 21.1938 12.5461 21.2998 12.6281 21.378C12.7102 21.4561 12.8215 21.5 12.9375 21.5H19.0625C19.1785 21.5 19.2898 21.4561 19.3719 21.378C19.4539 21.2998 19.5 21.1938 19.5 21.0833V19.2292C19.4996 19.1646 19.4836 19.1009 19.4532 19.0431C19.4229 18.9853 19.379 18.9349 19.325 18.8958L16 16.5Z",
    stroke: "#ACADAE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassCircle);
export default __webpack_public_path__ + "static/media/hourglass-circle.6208ca3187832443798b1e5aeb33e34a.svg";
export { ForwardRef as ReactComponent };